import React from 'react';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import CommonBalanceReceipt from './common-includes/CommonBalanceReceipt';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';
import { getConfiguration } from '../../utils';


function DetailedBalance(props) {
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};
	const conf = getConfiguration();
	return (
		<body style={additionalStyle}>
			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={getLabel('retail.detailed_balance')}></ShopReceiptHeader>
			
			<CommonBalanceReceipt showFromToDate={false} 
								  showTerminalBalance={true}
								  showPvend={false}
								  showMov={true}
								  showTotOperations={true}
								  showEffectiveAmount={true}
								  showTotalWithoutSign={!conf.nas}
								  detailedBalanceData={props.detailedBalanceData}>
			
			</CommonBalanceReceipt>
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default DetailedBalance;